import { ReactNode, MouseEvent } from 'react';

enum ModalVerticalPosition {
  Middle = 'middle',
}

enum ModalHorizontalPosition {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

interface IModal {
  children: ReactNode;
  zIndex?: number;
  contentIsFullWidth?: boolean;
  contentIsFullHeight?: boolean;
  contentClassName?: string;
  verticalPosition?: ModalVerticalPosition;
  horizontalPosition?: ModalHorizontalPosition;
  backgroundColor?: string;
  onClose?: (e: MouseEvent | KeyboardEvent) => void;
  className?: string;
  classNameBackLayer?: string;
}

export { ModalVerticalPosition, ModalHorizontalPosition };
export default IModal;
